import { Analytics, CheckoutDetails, EventProperties } from '.';

interface DynaTraceRum {
  sendSessionProperties: (
    arg1: unknown,
    arg2: unknown,
    props: EventProperties,
    arg4: unknown
  ) => void;
}

export type WindowWithDynaTrace = Window & {
  dtrum?: DynaTraceRum;
};

declare const window: WindowWithDynaTrace;

interface DynaTraceRumClient {
  sendSessionProperties: (props: EventProperties) => void;
}

const dynaTrace: DynaTraceRumClient = {
  sendSessionProperties(props: EventProperties) {
    window.dtrum?.sendSessionProperties(null, null, props, null);
  },
};

export const dynaTraceClient: Analytics = {
  initialize(): void {
    // noOp
  },
  setApplication(): void {
    // noOp
  },
  setSelectedOffer(): void {
    // noOp
  },
  setOrder(): void {
    // noOp
  },
  identify(buyerId: string): void {
    dynaTrace.sendSessionProperties({ buyer_id: buyerId });
  },
  setCheckoutDetails(details: CheckoutDetails): void {
    const { merchantID, programID } = details;
    dynaTrace.sendSessionProperties({
      merchant_id: merchantID,
      program_id: programID,
    });
  },
  trackLogout(): void {
    // noOp
  },
  track() {
    // noOp
  },
  setAdditionalContext(properties: EventProperties): void {
    if ('decibel_session_id' in properties) {
      dynaTrace.sendSessionProperties(properties);
    }
  },
};
